import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Heart, Loader2, LogIn } from "lucide-react";
import { useMember } from "../context/MemberContext";
import VenueCard from "./VenueCard";
import MemberDialog from "./MemberDialog";
import { getVenue } from "../mock/mockData";

const FavoritesTool = () => {
  const { member, API } = useMember();
  const [favVenues, setFavVenues] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dlg, setDlg] = useState(false);

  useEffect(() => {
    if (!member) { setFavVenues([]); return; }
    setLoading(true);
    (async () => {
      const slugs = member.favorites || [];
      const resolved = await Promise.all(
        slugs.map(async (s) => {
          const v = getVenue(s);
          if (v) return v;
          try { const r = await axios.get(`${API}/firms/${s}`); return r.data; } catch { return null; }
        })
      );
      setFavVenues(resolved.filter(Boolean));
      setLoading(false);
    })();
  }, [member, API]);

  return (
    <div className="bg-white rounded-2xl border border-[#F0DDE0] p-6 sm:p-8" data-testid="favorites-tool">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-[#C15B6B] to-[#9E2A3B] flex items-center justify-center">
          <Heart className="w-6 h-6 text-white" fill="white" />
        </div>
        <div>
          <h1 className="font-display text-2xl font-bold text-[#2A2224]">Favorilerim</h1>
          <p className="text-sm text-[#7C6E70]">Favori olarak işaretlediğiniz mekan ve firmalar</p>
        </div>
      </div>

      {!member ? (
        <div className="py-12 text-center" data-testid="favorites-login-prompt">
          <Heart className="w-12 h-12 mx-auto mb-4 text-[#E7A9B0]" />
          <p className="text-[#5b4d4f] font-medium">Favorilerinizi görmek için üye girişi yapın</p>
          <p className="text-sm text-[#9c8f90] mt-1 max-w-sm mx-auto">
            Mekan ve firma sayfalarındaki kalp ikonuna tıklayarak favori eklediklerinizi burada bir arada görürsünüz.
          </p>
          <button
            onClick={() => setDlg(true)}
            data-testid="favorites-login-btn"
            className="mt-5 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-gradient-to-r from-[#C15B6B] to-[#9E2A3B] text-white text-sm font-medium hover:shadow-lg transition-all"
          >
            <LogIn className="w-4 h-4" /> Üye Ol / Üye Girişi
          </button>
          <MemberDialog open={dlg} onOpenChange={setDlg} />
        </div>
      ) : loading ? (
        <div className="py-16 flex justify-center"><Loader2 className="w-7 h-7 animate-spin text-[#9E2A3B]" /></div>
      ) : favVenues.length === 0 ? (
        <div className="py-12 text-center text-[#7C6E70]" data-testid="favorites-empty">
          <Heart className="w-12 h-12 mx-auto mb-3 text-[#E7A9B0]" />
          Henüz favori eklemediniz. Mekan sayfalarındaki{" "}
          <Heart className="w-3.5 h-3.5 inline text-[#9E2A3B]" /> ikonuna tıklayarak ekleyebilirsiniz.
          <div className="mt-4">
            <Link to="/kategori/dugun-salonlari" className="text-[#9E2A3B] font-medium hover:underline">Mekanları keşfet →</Link>
          </div>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5" data-testid="favorites-grid">
          {favVenues.map((v) => <VenueCard key={v.slug || v.id} venue={v} />)}
        </div>
      )}
    </div>
  );
};

export default FavoritesTool;
